import { gql } from '@apollo/client'

export default gql`
  query getAllInAppNotifications($email: String!, $id: String!) {
    getAllInAppNotifications(
      id: $id,
      email: $email
    ) {
      data {
        data {
          auto_renew_product_id
          auto_renew_status
          auto_renew_status_change_date
          auto_renew_status_change_date_ms
          auto_renew_status_change_date_pst
          bid
          bvrs
        }
        pendingRenewalInfo {
        auto_renew_product_id
        auto_renew_status
        original_transaction_id
        product_id
        }
        environment
        expiresDate
        id
        notificationType
        originalPurchaseDate
        originalTransactionId
        purchaseDate
        transactionId
        updatedAt
      }
    }
  }
`
